import Reflux from "reflux";
import API from "../service/API";

const LoaderActions = Reflux.createActions({
  loadJSON: { asyncResult: true, children: ["complete", "fail"] },
});

LoaderActions.loadJSON.listen(function ({ url, key }) {
  API.getJSON(url)
    .then((res) => this.complete(res, key))
    .catch(this.fail);
});

export default LoaderActions;
